const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class DevelopmentOfPolitics extends Event {
    constructor(){
        super(
            Age.AgeA,
            EventNames.DevelopmentOfPolitics,
            "Each player draws 3 military cards.",
            {}
        )
    }
}

module.exports = DevelopmentOfPolitics;